import { all, takeEvery, call, put } from "redux-saga/effects";
import * as actionTypes from "../constants/actionTypes";
import * as actions from '../actions'
import axios from '../services';
import { sessionExpiredMsg } from "../constants/constants";

function* getExploreData(action) {
    try {
        let responseUser, deselectedList;
        if(action.payload.filterFlag == false) {
            responseUser = yield axios
                .get("/users")
                .then(async response => response)
                .catch(async error => {
                    return error;
                });
            
            if(responseUser.data.data.userContestFilter == 'global') {
                let list = [];
                let responseFilter = yield axios.get(`/contests/filter-contest-list`)
                    .then(async response => response)
                    .catch(async error => {
                        return error;
                    });
                if(responseFilter.status == 200) {
                    responseFilter.data.data.map(category => {
                        let contest = category.contest.map(item => {
                            if(category._id != 'GLOBAL' && category._id != responseUser.data.data.locationInfo.country) {
                                list.push(item.name);
                            }
                        });
                    })
                }
                deselectedList = list.join(',');
            } else {
                deselectedList = responseUser.data.data.userContestFilter;
            }
        } else {
            deselectedList = action.payload.deselectedList;
        }
            
        let response = yield axios.post(`/users/explore?skip=${action.payload.Length}&limit=5`, {
            contest: deselectedList
        })
            .then(async response => response)
            .catch(async error => {
                return error;
            });

        if (response == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else if (response.status == 200) {
            yield put(actions.getExploreDataSuccess({
                exploreFeed: response.data.data,
                newData: action.payload.newData
            }));
        } else if (response) {
            yield put(actions.modalOpen({ message: (response.message)}));
            yield put(actions.getExploreDataSuccess({ exploreFeed:'',newData:''}))
        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }
    } catch (error) {

        console.log("ERROR FROM SAGA explore", error.message);
        yield put(actions.hideAppLoader());        
    }
}

function* postShareCount(action) {
    let { e } = action.payload;
    try {
        let response = yield axios.post(`users/post-share-count`, {
            mediaId: action.payload.mediaId,
            contestName: action.payload.contestName,
            userId: action.payload.userId
        },
        {
            headers: {
                "Content-Type": "application/json",
                "Authorization": action.payload.token
            }
        })
            .then(async response => response)
            .catch(async error => {
                return error;
            });
        if (response == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else if (response.status == 200) {
            e.innerHTML = Number(e.innerHTML) + 1;
            yield put(actions.socialShareModalClose())
            console.log(response)
        } else if (response) {
            yield put(actions.modalOpen({ message: (response.message)}));
            yield put(actions.hideAppLoader());

        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }
    } catch (error) {

        console.log("ERROR FROM SAGA explore", error.message);  
        yield put(actions.hideAppLoader());

    }
}

export default function* rootsaga() {
    yield takeEvery(actionTypes.GET_EXPLORE_DATA, getExploreData);
    yield takeEvery(actionTypes.SOCIAL_SHARE_COUNT,postShareCount);
}